import { render, staticRenderFns } from "./Paciente.vue?vue&type=template&id=9b48ca8c"
import script from "./Paciente.vue?vue&type=script&lang=js"
export * from "./Paciente.vue?vue&type=script&lang=js"
import style0 from "./Paciente.vue?vue&type=style&index=0&id=9b48ca8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports